import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../assets/new/ico_user.png';
import _imports_1 from './../assets/new/ico_list.png';
import _imports_2 from './../assets/new/ico_shop.png';
import _imports_3 from './../assets/logo.png';
import _imports_4 from '@/assets/new/ico_menu.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-3a1d8ef8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "header" };
var _hoisted_2 = { class: "menu" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_1 }, null, -1); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_2 }, null, -1); });
var _hoisted_7 = { class: "logo" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_4 }, null, -1); });
var _hoisted_9 = [
    _hoisted_8
];
var _hoisted_10 = { class: "mobile-menu" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_1 }, null, -1); });
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_2 }, null, -1); });
var _hoisted_13 = { key: 0 };
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_16 = { class: "logo" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
                class: _normalizeClass(["font-ris profile", [$data.router.currentRoute.path == '/profile' ? 'selected' : '', $data.store.getters.isLogged ? 'logged-in' : 'not-logged']]),
                onClick: _cache[1] || (_cache[1] = function ($event) { return ($data.store.getters.isLogged ? $data.store.commit('goTo', '/profile') : $options.login()); })
            }, [
                ($data.store.getters.isLogged)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($data.store.getters.getUser.username), 1))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[0] || (_cache[0] = function ($event) { return ($options.login()); })
                    }, [
                        _createTextVNode("Log In "),
                        _hoisted_4
                    ]))
            ], 2),
            _createElementVNode("span", {
                class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/' ? 'selected' : '']),
                onClick: _cache[2] || (_cache[2] = function ($event) { return ($data.router.push('/')); })
            }, "Home", 2),
            _createElementVNode("span", {
                class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/leaderboard' ? 'selected' : '']),
                onClick: _cache[3] || (_cache[3] = function ($event) { return ($data.router.push('/leaderboard')); })
            }, [
                _hoisted_5,
                _createTextVNode("Leaderboards")
            ], 2),
            _createElementVNode("span", {
                class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/shop' ? 'selected' : '']),
                onClick: _cache[4] || (_cache[4] = function ($event) { return ($data.router.push('/shop')); })
            }, [
                _hoisted_6,
                _createTextVNode("Shop")
            ], 2),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                    src: _imports_3,
                    onClick: _cache[5] || (_cache[5] = function ($event) { return ($data.router.push('/')); })
                })
            ])
        ]),
        _createElementVNode("div", {
            class: "mobile-menu-button",
            onClick: _cache[6] || (_cache[6] = function ($event) { return ($options.toggleMenu()); })
        }, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
            ($data.showMenu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mobile-menu-wrap",
                    ref: "menu",
                    onMouseleave: _cache[12] || (_cache[12] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return ($options.closeMenuOutside && $options.closeMenuOutside.apply($options, args));
                        })
                }, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/' ? 'selected' : '']),
                        onClick: _cache[7] || (_cache[7] = function ($event) { return ($options.route('/')); })
                    }, "Home", 2),
                    _createElementVNode("span", {
                        class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/leaderboard' ? 'selected' : '']),
                        onClick: _cache[8] || (_cache[8] = function ($event) { return ($options.route('/leaderboard')); })
                    }, [
                        _hoisted_11,
                        _createTextVNode("Leaderboards")
                    ], 2),
                    _createElementVNode("span", {
                        class: _normalizeClass(["font-ris", $data.router.currentRoute.path == '/shop' ? 'selected' : '']),
                        onClick: _cache[9] || (_cache[9] = function ($event) { return ($options.route('/shop')); })
                    }, [
                        _hoisted_12,
                        _createTextVNode("Shop")
                    ], 2),
                    _createElementVNode("span", {
                        class: _normalizeClass(["font-ris profile", [$data.router.currentRoute.path == '/profile' ? 'selected' : '', $data.store.getters.isLogged ? 'logged-in' : 'not-logged']]),
                        onClick: _cache[11] || (_cache[11] = function ($event) { return ($data.store.getters.isLogged ? $options.route('/profile') : $options.login()); })
                    }, [
                        ($data.store.getters.isLogged)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(" " + _toDisplayString($data.store.getters.getUser.username), 1)
                            ]))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onClick: _cache[10] || (_cache[10] = function ($event) { return ($options.login()); })
                            }, [
                                _hoisted_15,
                                _createTextVNode(" Log In")
                            ]))
                    ], 2)
                ], 544))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                    src: _imports_3,
                    onClick: _cache[13] || (_cache[13] = function ($event) { return ($data.router.push('/')); })
                })
            ])
        ])
    ]));
}
